export enum UserRoles {
  User = 'user',
  Editor = 'editor',
  Admin = 'admin',
  External = 'external',
}

export enum AttachmentTypes {
  Project = 'project',
  Cv = 'cv',
  Manuscript = 'manuscript',
  GrantLetter = 'grant_letter',
  SignedContract = 'signed_contract',
  OtherDocument = 'other_document',
  Budget = 'budget',
  FinishedManuscript = 'finished_manuscript',
  ApplicationDeclinedLetter = 'application_declined_letter',
}

export enum FileExtensions {
  Pdf = 'pdf',
  Docx = 'docx',
  Jpeg = 'jpeg',
  Doc = 'doc',
  Odt = 'odt',
  Xls = 'xls',
  Xlsx = 'xlsx',
  Rtf = 'rtf',
  Pages = 'pages',
  Mpeg = 'mpeg',
  Png = 'png',
  Zip = 'zip',
  Pptx = 'pptx',
  Tiff = 'tiff',
  Ods = 'ods',
  Txt = 'txt',
}

export enum ApplicationStatuses {
  Initiated = 'initiated',
  Submitted = 'submitted',
  Handling = 'handling',
  Approved = 'approved',
  Denied = 'denied',
}

export enum GrantStatuses {
  WorkInProgress = 'work_in_progress',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export enum SortTypes {
  Asc = 'asc',
  Desc = 'desc',
}

export const DefaultPaginatedQueryRowsPerPage = 25

export const DefaultPaginatedQueryPage = 0
// export const DefaultApplicationHandlingTimeInDays = 84 // 12 weeks
export const DefaultApplicationHandlingTimeInDays = 56 // 7 weeks

export function determineHttpContentTypeByExtension(extension: string) {
  let contentType = ''

  switch (extension) {
    case FileExtensions.Pdf:
      {
        contentType = 'application/pdf'
      }
      break
    case FileExtensions.Docx:
      {
        contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      }
      break
    case FileExtensions.Jpeg:
      {
        contentType = 'image/jpeg'
      }
      break
    case FileExtensions.Doc:
      {
        contentType = 'application/msword'
      }
      break
    case FileExtensions.Odt:
      {
        contentType = 'application/vnd.oasis.opendocument.text'
      }
      break
    case FileExtensions.Xls:
      {
        contentType = 'application/vnd.ms-excel'
      }
      break
    case FileExtensions.Xlsx:
      {
        contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
      break
    case FileExtensions.Rtf:
      {
        contentType = 'application/rtf'
      }
      break
    case FileExtensions.Pages:
      {
        contentType = 'application/vnd.apple.pages'
      }
      break
    case FileExtensions.Mpeg:
      {
        contentType = 'audio/mpeg'
      }
      break
    case FileExtensions.Png:
      {
        contentType = 'image/png'
      }
      break
    case FileExtensions.Zip:
      {
        contentType = 'application/zip'
      }
      break
    case FileExtensions.Pptx:
      {
        contentType = 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
      }
      break
    case FileExtensions.Tiff:
      {
        contentType = 'image/tiff'
      }
      break
    case FileExtensions.Ods:
      {
        contentType = 'application/vnd.oasis.opendocument.spreadsheet'
      }
      break
    case FileExtensions.Txt:
    default:
      {
        contentType = 'text/plain'
      }
      break
  }
  return contentType
}

export function determineExtensionByHttpContentType(mimeType: string) {
  switch (mimeType) {
    case 'application/pdf': {
      return FileExtensions.Pdf
    }
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
      return FileExtensions.Docx
    }
    case 'image/jpeg': {
      return FileExtensions.Jpeg
    }
    case 'application/msword': {
      return FileExtensions.Doc
    }
    case 'application/vnd.oasis.opendocument.text': {
      return FileExtensions.Odt
    }
    case 'application/vnd.ms-excel': {
      return FileExtensions.Xls
    }
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': {
      return FileExtensions.Xlsx
    }
    case 'application/rtf': {
      return FileExtensions.Rtf
    }
    case 'application/vnd.apple.pages': {
      return FileExtensions.Pages
    }
    case 'audio/mpeg': {
      return FileExtensions.Mpeg
    }
    case 'image/png': {
      return FileExtensions.Png
    }
    case 'application/zip': {
      return FileExtensions.Zip
    }
    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation': {
      return FileExtensions.Pptx
    }
    case 'image/tiff': {
      return FileExtensions.Tiff
    }
    case 'application/vnd.oasis.opendocument.spreadsheet': {
      return FileExtensions.Ods
    }
    case 'text/plain':
    default: {
      return FileExtensions.Txt
    }
  }
}
